var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from "../../UI";

const normalizeIndex = (index, length) => index >= 0 ? index % length : length + index;

const getVisibleIndices = (centerIndex, visibleCount, totalLength) => {
  const minIndex = -Math.floor(visibleCount / 2);
  const rawIndices = [];
  for (let i = 0; i < visibleCount; i += 1) {
    rawIndices.push(centerIndex + minIndex + i);
  }
  return rawIndices.map((i) => normalizeIndex(i, totalLength));
};

const getVisibleItems = (data, currentIndex, visibleCount) => {
  if (!data.length) {
    return [];
  }

  let visibleIndices = data.map((_item, index) => index);

  if (data.length > visibleCount) {
    visibleIndices = getVisibleIndices(currentIndex, visibleCount, data.length);
  }

  const visibleItems = visibleIndices.map((i) => data[i]);
  return visibleItems;
};

export default class VictimSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // initialize slider with a victim that has an image
      currentIndex: 0
    };
  }

  componentDidMount() {
    const { initialIndex } = this.props;
    this.setState({
      currentIndex: initialIndex || 0
    });
  }

  slide(dir) {
    let { currentIndex } = this.state;
    const { children } = this.props;
    currentIndex = normalizeIndex(currentIndex + dir, children.length);
    this.setState({ currentIndex });
  }

  render() {
    const { children, visibleCount } = this.props;
    const { currentIndex } = this.state;
    const items = getVisibleItems(children, currentIndex, visibleCount);

    return /*#__PURE__*/(
      _jsx("div", { className: "slider" }, void 0,
      children.length > visibleCount && /*#__PURE__*/
      _jsx("div", { className: "slider-buttons" }, void 0, /*#__PURE__*/
      _jsx("button", { className: "slider-btn", onClick: () => this.slide(-1) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "angle-left" })
      ), /*#__PURE__*/
      _jsx("button", { className: "slider-btn", onClick: () => this.slide(1) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "angle-right" })
      )
      ), /*#__PURE__*/

      _jsx("div", { className: "slider-items" }, void 0, items)
      ));

  }
}